class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this.searchRequestId = 0;
    this.latestCarResults = null;

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    this.addEventListener('click', this.onSearchTermClick.bind(this));
  }

  onSearchTermClick(event) {
    if (!event.target.closest('.predictive-search__item--term')) return;

    event.preventDefault();
    this.input.form.requestSubmit();
  }

  getQuery() {
    return this.input.value.trim();
  }

  getCarSearchLabels() {
    return window.carMetaobjectSearchConfig?.labels || {};
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
      this.latestCarResults = null;
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if(event.submitter.closest('product-form')) return;
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.searchRequestId += 1;
      this.latestCarResults = null;
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    return false;
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    const requestId = ++this.searchRequestId;
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey], this.cachedResults[queryKey][2] || null, requestId);
      this.searchCarResults(searchTerm, requestId, queryKey);
      return;
    }

    const tagToInclude = window.cart.attributes.Filter;
    const productQuery = (tagToInclude && tagToInclude !== 'undefined') ? `${tagToInclude} ${searchTerm}`: searchTerm;

    const productPromise = fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(productQuery)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=10&${encodeURIComponent('resources[limit_scope]')}=each&${encodeURIComponent('resources[options][fields]')}=title,product_type,variants.title,body,tag,variants.sku,variants.barcode,variants.title,vendor&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      });

    const otherPromise = fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=collection,page,article,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      });

    const carPromise = this.searchCarResults(searchTerm, requestId, queryKey);

    Promise.all([productPromise, otherPromise])
      .then(async ([productResultsText, otherResultsText]) => {
        if (requestId !== this.searchRequestId) return;

        const productResultsDOM = new DOMParser().parseFromString(productResultsText, 'text/html');
        const productItems = productResultsDOM.querySelectorAll('#predictive-search-results-products-list li');
        const otherResultsMarkup = new DOMParser().parseFromString(otherResultsText, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        const carResults = (await carPromise) || this.latestCarResults || { merken: [], models: [], uitvoeringen: [], total: 0, complete: true };

        if (requestId !== this.searchRequestId) return;

        if (productItems.length > 0) {
            const productResultsMarkup = productResultsDOM.querySelector('#shopify-section-predictive-search').innerHTML;
            this.cachedResults[queryKey] = [productResultsMarkup, otherResultsMarkup, carResults];
            this.renderSearchResults([productResultsMarkup, otherResultsMarkup], carResults, requestId);
        } else {
            fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=10&${encodeURIComponent('resources[limit_scope]')}=each&${encodeURIComponent('resources[options][fields]')}=title,product_type,variants.title,body,tag,variants.sku&section_id=predictive-search`)
                .then(response => response.text())
                .then(fallbackProductResultsText => {
                    if (requestId !== this.searchRequestId) return;
                    const fallbackProductResultsMarkup = new DOMParser().parseFromString(fallbackProductResultsText, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                    this.cachedResults[queryKey] = [fallbackProductResultsMarkup, otherResultsMarkup, carResults];
                    this.renderSearchResults([fallbackProductResultsMarkup, otherResultsMarkup], carResults, requestId);
                });
        }
      })
      .catch((error) => {
        if (requestId !== this.searchRequestId) return;
        this.close();
        throw error;
      });
  }

  searchCarResults(searchTerm, requestId, queryKey) {
    if (!window.CarMetaobjectSearch) {
      return Promise.resolve({ merken: [], models: [], uitvoeringen: [], total: 0, complete: true });
    }

    return window.CarMetaobjectSearch.search(searchTerm, {
      onProgress: (results) => {
        if (requestId !== this.searchRequestId || !results) return;
        this.latestCarResults = results;
        if (this.cachedResults[queryKey]) {
          this.cachedResults[queryKey][2] = results;
        }
        this.renderCarResults(results);
        this.updateLiveRegionWithCarResults(results);
      },
    }).then((results) => {
      if (requestId !== this.searchRequestId || !results) return null;
      this.latestCarResults = results;
      if (this.cachedResults[queryKey]) {
        this.cachedResults[queryKey][2] = results;
      }
      return results;
    }).catch(() => {
      return { merken: [], models: [], uitvoeringen: [], total: 0, complete: true };
    });
  }

  escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  getCarResultTitle(entry, type) {
    if (type === 'model') {
      return [entry.merkNaam, entry.naam].filter(Boolean).join(' ');
    }

    if (type === 'uitvoering') {
      return [entry.merkNaam, entry.modelNaam, entry.naam].filter(Boolean).join(' ')
        || entry.volledigeNaam
        || entry.naam;
    }

    return entry.naam;
  }

  buildCarResultItems(entries, type) {
    return entries.map((entry, index) => {
      const title = this.escapeHtml(this.getCarResultTitle(entry, type));
      const carDataAttr = type === 'uitvoering'
        ? ` data-car-uitvoering="${this.escapeHtml(JSON.stringify({
            id: entry.id,
            naam: entry.naam,
            volledigeNaam: entry.volledigeNaam,
            groep: entry.groep || '',
            typeAuto: entry.typeAuto || '',
            merkNaam: entry.merkNaam || '',
            modelNaam: entry.modelNaam || '',
            url: entry.url,
          }))}"`
        : '';

      return `
        <li
          id="predictive-search-option-car-${type}-${index + 1}"
          class="predictive-search__list-item"
          role="option"
          aria-selected="false"
        >
          <a href="${this.escapeHtml(entry.url)}" class="predictive-search__item link link--text" tabindex="-1"${carDataAttr}>
            <div class="predictive-search__item-content predictive-search__item-content--centered">
              <p class="predictive-search__item-heading">${title}</p>
            </div>
          </a>
        </li>
      `;
    }).join('');
  }

  buildCarSection(label, type, entries, headingId) {
    if (!entries?.length) return '';

    const typeModifier = type === 'uitvoering' ? ' predictive-search__car-type--uitvoeringen' : '';

    return `
      <div class="predictive-search__car-type${typeModifier}">
        <h2 id="${headingId}" class="h6 predictive-search__heading">${this.escapeHtml(label)}</h2>
        <ul
          class="predictive-search__results-list list-unstyled"
          role="group"
          aria-labelledby="${headingId}"
        >
          ${this.buildCarResultItems(entries, type)}
        </ul>
      </div>
    `;
  }

  buildCarResultsMarkup(carResults) {
    if (!carResults || !carResults.total) return '';

    const labels = this.getCarSearchLabels();
    const sections = [
      this.buildCarSection(labels.merken || 'Merken', 'merk', carResults.merken, 'predictive-search-car-merken'),
      this.buildCarSection(labels.modellen || 'Modellen', 'model', carResults.models, 'predictive-search-car-modellen'),
      this.buildCarSection(labels.uitvoeringen || 'Uitvoeringen', 'uitvoering', carResults.uitvoeringen, 'predictive-search-car-uitvoeringen'),
    ].filter(Boolean);

    return `
      <div class="predictive-search__cars-wrapper" data-predictive-search-cars>
        ${sections.join('')}
      </div>
    `;
  }

  ensureResultsShell() {
    let results = this.predictiveSearchResults.querySelector('#predictive-search-results');
    if (!results) {
      this.predictiveSearchResults.innerHTML = `
        <div id="predictive-search-results" role="listbox">
          <div id="predictive-search-results-groups-wrapper" class="container">
            <div class="row predictive-search__results-groups-wrapper predictive-search__results-groups-wrapper--no-products predictive-search__results-groups-wrapper--no-suggestions"></div>
          </div>
          <div class="predictive-search__loading-state" aria-hidden="true">
            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
          <span class="hidden" data-predictive-search-live-region-count-value></span>
        </div>
      `;
      results = this.predictiveSearchResults.querySelector('#predictive-search-results');
    }

    let wrapperOuter = results.querySelector('#predictive-search-results-groups-wrapper');
    if (!wrapperOuter) {
      wrapperOuter = document.createElement('div');
      wrapperOuter.id = 'predictive-search-results-groups-wrapper';
      wrapperOuter.className = 'container';
      wrapperOuter.innerHTML = '<div class="row predictive-search__results-groups-wrapper predictive-search__results-groups-wrapper--no-products predictive-search__results-groups-wrapper--no-suggestions"></div>';
      results.insertBefore(wrapperOuter, results.firstChild);
    }

    let row = wrapperOuter.querySelector('.predictive-search__results-groups-wrapper');
    if (!row) {
      row = document.createElement('div');
      row.className = 'row predictive-search__results-groups-wrapper predictive-search__results-groups-wrapper--no-products predictive-search__results-groups-wrapper--no-suggestions';
      wrapperOuter.appendChild(row);
    }

    let suggestionsGroup = row.querySelector('.predictive-search__result-group-suggestions');
    if (!suggestionsGroup) {
      suggestionsGroup = document.createElement('div');
      suggestionsGroup.className = 'predictive-search__result-group col-xs-12 col-md predictive-search__result-group-suggestions';
      row.insertBefore(suggestionsGroup, row.firstChild);
    }

    return { results, row, suggestionsGroup };
  }

  renderCarResults(carResults) {
    if (!carResults) return;

    const markup = this.buildCarResultsMarkup(carResults);
    const existing = this.predictiveSearchResults.querySelector('[data-predictive-search-cars]');

    if (!markup) {
      existing?.remove();
      return;
    }

    const { suggestionsGroup, row } = this.ensureResultsShell();
    row.classList.remove('predictive-search__results-groups-wrapper--no-suggestions');

    if (existing) {
      existing.outerHTML = markup;
    } else {
      suggestionsGroup.insertAdjacentHTML('afterbegin', markup);
    }

    this.setAttribute('results', true);
    this.open();
  }

  updateLiveRegionWithCarResults(carResults) {
    const liveRegion = this.querySelector('[data-predictive-search-live-region-count-value]');
    if (!liveRegion) return;

    const labels = this.getCarSearchLabels();
    const nativeText = liveRegion.dataset.nativeCountText || liveRegion.textContent || '';
    const carCount = carResults?.total || 0;

    if (!carCount) {
      if (liveRegion.dataset.nativeCountText) {
        liveRegion.textContent = liveRegion.dataset.nativeCountText;
        this.setLiveRegionText(liveRegion.textContent);
      }
      return;
    }

    const carText = carCount === 1
      ? (labels.resultsOne || '[count] autoresultaat').replace('[count]', String(carCount))
      : (labels.resultsOther || '[count] autoresultaten').replace('[count]', String(carCount));

    if (nativeText && !/geen resultaten|no results/i.test(nativeText)) {
      liveRegion.textContent = `${nativeText.replace(/:\s*$/, '')}, ${carText}`;
    } else {
      liveRegion.textContent = carText;
    }

    this.setLiveRegionText(liveRegion.textContent);
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults([productResultsMarkup, otherResultsMarkup], carResults = null, requestId = this.searchRequestId) {
    if (requestId !== this.searchRequestId) return;

    const productResultsDOM = new DOMParser().parseFromString(productResultsMarkup, 'text/html');
    const otherResultsDOM = new DOMParser().parseFromString(otherResultsMarkup, 'text/html');

    const productGroup = productResultsDOM.querySelector('.predictive-search__result-group-products');
    const suggestionsGroup = otherResultsDOM.querySelector('.predictive-search__result-group-suggestions');
    const hasNativeResults = Boolean(
      otherResultsDOM.querySelector('#predictive-search-results-groups-wrapper') ||
      productResultsDOM.querySelector('#predictive-search-results-groups-wrapper')
    );

    if (hasNativeResults) {
      this.predictiveSearchResults.innerHTML = otherResultsMarkup;

      const wrapper = this.predictiveSearchResults.querySelector('.predictive-search__results-groups-wrapper');

      if (productGroup && wrapper) {
          wrapper.appendChild(document.importNode(productGroup, true));
          wrapper.classList.remove('predictive-search__results-groups-wrapper--no-products');
      }

      if (!suggestionsGroup && wrapper) {
          wrapper.classList.add('predictive-search__results-groups-wrapper--no-suggestions');
      }

      if (!wrapper && productGroup) {
          this.predictiveSearchResults.innerHTML = productResultsMarkup;
      }
    } else if (carResults?.total) {
      this.predictiveSearchResults.innerHTML = '';
      this.ensureResultsShell();
    } else {
      this.predictiveSearchResults.innerHTML = otherResultsMarkup || productResultsMarkup;
    }

    const liveRegion = this.querySelector('[data-predictive-search-live-region-count-value]');
    if (liveRegion) {
      liveRegion.dataset.nativeCountText = liveRegion.textContent || '';
    }

    const resolvedCarResults = carResults || this.latestCarResults;
    if (resolvedCarResults) {
      this.renderCarResults(resolvedCarResults);
      this.updateLiveRegionWithCarResults(resolvedCarResults);
    }

    this.setAttribute('results', true);
    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    const liveRegion = this.querySelector('[data-predictive-search-live-region-count-value]');
    if (liveRegion) this.setLiveRegionText(liveRegion.textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - this.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
      this.latestCarResults = null;
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
